export function isPendingOnboardMerchant() {
  const raw = localStorage.getItem("merchant");
  if (!raw) return false;

  try {
    const currentUser = JSON.parse(raw);
    return currentUser?.merchant?.status === "PENDING_ONBOARD";
  } catch {
    return false;
  }
}

export function isOnboardingPaused() {
  return String(process.env.VUE_APP_MERCHANT_ONBOARDING_ENABLED || "").trim().toLowerCase() === "false";
}

export function isPendingActivationUser() {
  if (!isPendingOnboardMerchant()) return false;

  try {
    const currentUser = JSON.parse(localStorage.getItem("merchant"));
    return currentUser?.status === "PENDING_ACTIVATION";
  } catch {
    return false;
  }
}


export function getOnboardingRedirect(profile) {
  let user = profile;

  if (!user) {
    const raw = localStorage.getItem("merchant");
    if (!raw) return null;
    try {
      user = JSON.parse(raw);
    } catch {
      return null;
    }
  }

  if (user?.merchant?.status !== "PENDING_ONBOARD") return null;

  return user.status === "PENDING_ACTIVATION" ? "/update-mobile" : "/verification/ssu";
}
